import { navigation, site, lean } from "@/content";
export default function LeanFooter() {
  const socials = site.socials.map((s) => ({ ...s, key: s.key }));

  const navLinks = navigation.lean.links.map((l) => ({ text: l.label, href: l.href }));

  return (
    <footer className="py-12 border-t border-stone-200 bg-[#FAFAF8] dark:border-white/[0.06] dark:bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center gap-8">
          {/* Logo */}
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-600 dark:bg-orange-500">
              <i className="ri-settings-3-line text-white text-sm dark:text-[#0A0A0A]"></i>
            </div>
            <span className="font-extrabold text-lg tracking-tight text-stone-900 dark:text-white">
              {navigation.lean.logo.name}
              <span className="text-orange-600 dark:text-orange-500">{navigation.lean.logo.suffix}</span>
            </span>
          </div>

          {/* Nav */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-stone-600 text-sm dark:text-white/55">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="hover:text-stone-900 transition-colors cursor-pointer dark:hover:text-white">
                {link.text}
              </a>
            ))}
          </div>

          {/* Contacts */}
          <div className="flex flex-wrap items-center justify-center gap-4 text-stone-600 text-sm dark:text-white/55">
            <a href="mailto:amo@vnedrim-crm.ru" className="hover:text-stone-900 transition-colors cursor-pointer dark:hover:text-white">
              amo@vnedrim-crm.ru
            </a>
            <span className="text-stone-600 dark:text-white/55">·</span>
            <a href="tel:+79774217997" className="hover:text-stone-900 transition-colors cursor-pointer dark:hover:text-white">
              +7 (977) 421-79-97
            </a>
          </div>

          {/* Socials */}
          <div className="flex gap-3">
            {socials.map((s) => (
              <a
                key={s.key}
                href={s.href}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-200 text-stone-600 hover:bg-stone-800 hover:text-white dark:bg-white/[0.08] dark:text-white/60 dark:hover:bg-orange-500 dark:hover:text-[#0C0C0E] transition-all cursor-pointer"
              >
                <i className={`${s.icon} text-sm`}></i>
              </a>
            ))}
          </div>

          {/* Bottom */}
          <div className="flex flex-col sm:flex-row items-center gap-4 text-stone-600 text-xs dark:text-white/55">
            <p>{lean.footer.copyright}</p>
            <a href="/policy_pd.docx" className="hover:text-stone-600 transition-colors cursor-pointer dark:hover:text-white">
              Политика обработки персональных данных
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}